import type { I18n } from './types'
import { LANGUAGES, Lang, SOURCE_LANG, SOURCE_TEXTS } from './languages'
import { applyDateLocale } from './dates'

let current: { lang: Lang; texts: I18n } = { lang: SOURCE_LANG, texts: SOURCE_TEXTS }

/**
 * The texts of the active language, for code outside React components
 * (helpers, column builders, alerts in plain functions).
 *
 * Call it when the text is needed, never at module load:
 *   const label = () => getTexts().shared.common.save     // right
 *   const LABEL = getTexts().shared.common.save           // wrong: frozen in the start language
 */
export function getTexts(): I18n {
    return current.texts
}

export function getLang(): Lang {
    return current.lang
}

/** locale of the active language for numbers (toLocaleString on a number, Intl.NumberFormat), e.g. 'de-DE' */
export function locale(): string {
    return LANGUAGES[current.lang].locale
}

/** locale of the active language for dates (toLocaleDateString, Intl.DateTimeFormat): English is 04.11.2026 */
export function dateLocale(): string {
    return LANGUAGES[current.lang].dateLocale
}

/** @internal set by I18nProvider when a language is loaded */
export function setCurrentTexts(lang: Lang, texts: I18n): void {
    current = { lang, texts }
    applyDateLocale(lang)
    if (typeof document !== 'undefined') document.documentElement.lang = lang
}
